import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, forkJoin } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { UserService } from '../user/user.service';

interface UserProfile {
  data: { [key: string]: any };
}

interface RequiredFields {
  fields: { [key: string]: any };
}

@Injectable({
  providedIn: 'root'
})
export class ValidateInfoExtraRegisterGuard implements CanActivate {
  constructor(
    private user: UserService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return forkJoin([
      this.user.getDataUserExtraInfo() as Observable<RequiredFields>, // Campos requeridos
      this.user.getDataUserExtraInfoProfile() as Observable<UserProfile> // Datos actuales del usuario
    ]).pipe(
      map(([requiredFields, userProfile]) => {
        // Verificar si ambos objetos son válidos
        if (requiredFields?.fields && userProfile?.data) {
          // Comparar los campos requeridos con los datos del usuario
          const isComplete = this.validateFields(requiredFields.fields, userProfile.data);
          if (isComplete) {
            // Si todos los campos están completos, permitir acceso
            return true;
          }
        }
        // Si no están completos, redirigir a la página de registro
        this.router.navigate(['register-info-extra']);
        return false;
      }),
      catchError(error => {
        console.error('Error al obtener datos del perfil o información adicional:', error);
        // En caso de error, redirigir a la página de registro
        return [true];
      })
    );
  }

  private validateFields(requiredFields: { [key: string]: any }, userData: { [key: string]: any }): boolean {
    // Verificar que cada campo requerido exista y no esté vacío en los datos del usuario
    return Object.keys(requiredFields).every(key => userData[key] && userData[key].length > 0);
  }
}
